import { Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { UserState } from "src/app/states/user.state";

import { Observable, of } from "rxjs";
@Pipe({
  name: "validatePermission",
  standalone: false,
})
export class ValidatePermissionPipe implements PipeTransform {
  constructor(private store?: Store) {}
  transform(submodules, route, permissions): Observable<any> {
    // const submodules = this.store.selectSnapshot(UserState.submodules);
    const submodule = submodules.find(
      (sub) =>
        sub.Route_Submodule === route &&
        sub.Permissions.find((p) => permissions.includes(p.Name_Permission))
    );

    return of(!!submodule);
  }
}
